import { EventEmitter } from 'events';

export const ProtonEventEmitter = new EventEmitter();

export const EVENTS = {
  MFA_REQUIRED: 'MFA-required-error'
} as const;
